export const STATUS_OUTCOMES = Object.freeze({
  applied: "applied",
  unchanged: "unchanged",
  refreshing: "refreshing",
  ignored: "ignored",
  unavailable: "unavailable"
})

export function isStatusObject(payload) {
  return payload !== null && typeof payload === "object" && !Array.isArray(payload)
}

export function hasConflictingIdentity(payload, item) {
  if (!isStatusObject(payload)) return false

  return (Object.hasOwn(payload, "upload_id") && payload.upload_id !== item.dataset.uploadId) ||
    (Object.hasOwn(payload, "purpose") && payload.purpose !== item.dataset.uploadPurpose)
}

export function statusTimeElement(item) {
  return item.querySelector("time[datetime]:not([data-upload-expires-at])")
}

// The view supplies Ruby's public vocabulary. Missing metadata fails validation
// rather than giving the browser a second, potentially divergent state policy.
export function validateStatus(list, item, payload) {
  if (!isStatusObject(payload) ||
      typeof payload.state !== "string" || !payload.state.trim() ||
      typeof payload.message !== "string" || !payload.message.trim() ||
      typeof payload.last_updated_at !== "string" || !payload.last_updated_at.trim()) return null

  let publicStates
  try {
    publicStates = JSON.parse(list.dataset.uploadPublicStates)
  } catch (_error) {
    return null
  }
  if (!Array.isArray(publicStates) || !publicStates.includes(payload.state)) return null

  const timeElement = statusTimeElement(item)
  const incomingTime = Date.parse(payload.last_updated_at)
  const currentTime = Date.parse(timeElement?.dateTime || "")
  if (!Number.isFinite(incomingTime) || !Number.isFinite(currentTime)) return null

  return { timeElement, incomingTime, currentTime }
}

export function showUnavailable(item) {
  const indicator = item.querySelector("[data-upload-update-unavailable]")
  if (indicator) indicator.hidden = false
  return STATUS_OUTCOMES.unavailable
}

export function clearUnavailable(item) {
  const indicator = item.querySelector("[data-upload-update-unavailable]")
  if (indicator) indicator.hidden = true
}
